import { Component, OnInit, OnDestroy,ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, ParamMap} from '@angular/router';
import { Observable } from 'rxjs';
import { Meta, Title } from "@angular/platform-browser";
import { CourseService }                  from '../_services/course.service';
import {Globals}                           from '../../Globals';
declare let gtag: any;
import storage from 'local-storage-fallback';



@Component({
  selector: 'course',
  styleUrls: ['./course.component.css'],
  templateUrl: './course.component.html'
})

export class CourseComponent implements OnDestroy, OnInit {
  post;
  id;
  tab;
  status;
  sections;
  quizs;
  enableComment = [];
  totalDuration;
  loadReviewData=false;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private courseService: CourseService,private meta: Meta,private title: Title, private globals: Globals){}
  ngOnInit() {
      this.activatedRoute.params.subscribe(params => {
        this.id = params['id'];
        this.courseService.find(this.id).subscribe(result => {
          this.tab = 'overview';
          this.post = result.data;
          this.title.setTitle(this.post.name);
          
          /*Google Analystic*/
          //gtag('config', this.globals.analystic, {'page_path': '/course/'+this.post.url});
          window.scroll(0,0)
        });
    });
  }
  loadLesson(){
    this.courseService.find(this.id, ['lessons', 'quiz']).subscribe(result => {
        this.sections = result.lessons.data;
        this.quizs = result.quiz.data;
    });
  }
  secondsToHms(d) {
    return Math.round((d / 3600) * 100) / 100;
  }
  loadRelateCourse(){
    if(!this.post.relateCourse)
    this.courseService.getRelateCourse(this.id, this.post.type).subscribe(result => {
      this.post.relateCourse = result.data;
    });
  }
  loadReview(){
    if(this.loadReviewData==false){
      this.loadReviewData=true;
    }
  }
  ngOnDestroy(){}

}
